export default {
  dashboard: "Dashboard",
  employee: {
    overview: "Employees",
  },
  category: {
    overview: "Categories",
  },
  material: {
    overview: "Materials",
  },
  machine: {
    overview: "Machines",
  },
  supplier: {
    overview: "Suppliers",
  },
  additionaleffort: {
    overview: "Additional Efforts",
  },
  customer: {
    overview: "Customers",
  },
  project: {
    overview: "Projects",
    costs: "Running Post-Calculation",
  },
  daysubmission: "Day submissions",
  daysubmission_open: "{count} open",
  userposition: {
    overview: "Employee-positions",
  },
  // Packets have no entry of their own any more; they are listed with the catalogue they bundle from.
  // These three are those lists' browser-tab titles.
  packet: {
    overview: "Packets",
    material: "Material packets",
    machine: "Machine packets",
    additional_effort: "Additional effort packets",
  },
  // Deliberately not "Billing": this entry is the wizard for billing hourly wage work, whereas
  // `billing.settings.*` is the SaaS subscription. Both once read "Billing" and collided in the
  // command palette's results.
  invoice: "[[HWI]]",
  file: {
    overview: "Files",
  },
  personnelplanning: "Personnel Planning",
  timetracking: "Time Tracking",
  settings: "Settings",
  logout: "Logout",
  // Labels the toolbar button that shows/hides the navigation on tablets and collapses it to a
  // rail on the desktop.
  toggle: "Toggle navigation",
  toggle_open: "Toggle navigation, {count} day submission open | Toggle navigation, {count} day submissions open",
  // Names the drawer's `nav` landmark. The app has a second set of links in the command palette,
  // so "Navigation" alone would not tell them apart in a landmark list.
  label: "Main navigation",
  tenant: {
    // The company block at the top of the drawer.
    label: "Signed-in company",
    // Prefixes the status line ("Active", "Grace period", ...) so it is not announced bare.
    subscription: "Subscription",
  },
}
